import { Marker, Popup } from "react-leaflet"
import L from "leaflet"


const WaypointMarker = ({ waypoint }) => {

    const DefaultIconC = L.icon({
        iconUrl: "/waypoint.png",
        iconSize: [22, 22],
    });

      
    return (
        <Marker position={[waypoint.lat, waypoint.lng]} icon={DefaultIconC}>
            <Popup>
                <p className="text-slate-200">Waypoint: </p>
                <p className="text-slate-200">Track kilometer: {waypoint.km}</p>
            </Popup>
        </Marker >
    )
}

export default WaypointMarker